import React, { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { AuthContext } from '../../contexts/AuthContext';
import getLoginType from '../../utils/loginConfig';
import Navbar from '../Navbar';
import Footer from './Footer';
import HeaderMenu from "../HeaderMenu"
import initFontAwesome from "../../utils/initFontAwesome";
import useDataCollect from '../../services/useDataCollect';
initFontAwesome();

export default function Layout(props) {
  const [toggle, setToggle] = useState(false);
  const { savedLoginType, logout } = useContext(AuthContext);
  const { withoutNavOptions } = props;

  useEffect(() => {
    const loginType = getLoginType();
    if (loginType.name !== savedLoginType) logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleMenu = () => {
    setToggle(!toggle);
  };
  
  useDataCollect()
  
  return (
    <div className="Layout">
      <Helmet title="Exámenes EFPA España">
      </Helmet>
      <HeaderMenu openMenu={toggle} toggle={toggleMenu} />
      <Navbar openMenu={toggle} className="NavbarSecondary" withoutNavOptions={withoutNavOptions} />
      <div className="Layout-container">
        <div className="row intranet-row">{props.children}</div>
      </div>
      <Footer />
      <Helmet>
        <script
          src="https://kit.fontawesome.com/87131fda1b.js"
          crossorigin="anonymous"
        ></script>
        <script src="https://cookie-cdn.cookiepro.com/scripttemplates/otSDKStub.js"
                type="text/javascript"
                charSet="UTF-8"
                data-domain-script="15fdeb90-5a6a-4a39-a65d-24d91c913114"></script>
        <script type="text/javascript">
          function OptanonWrapper() {}
        </script>
      </Helmet>
    </div>
  );
}
